export default {
  name: "interactiveSlide",
  title: "Interactive Slide",
  icon: require("./content-icon.svg"),
  category: "training"
}
